export default "__VITE_ASSET__7003271a__"